
// The user's tender evaluation stage
var TECL_UserTenderEvaluationStage = {

  /*
   * Method used to initialise the module
   */
  Initialise: function() {

    // Handle star rating change
    $("body").on("change.tenderEval", "[name='ratingCriteriaValue']", function() {

      var $starControl = $(this);
      var $controlCont = $starControl.closest(".rating-criteria-control");

      // Get the containing criteria item
      var $criteriaItem = $starControl.closest(".rating-criteria-item");
      var ratingRowCount = $criteriaItem.attr("data-ratingRowCount");

      if (ratingRowCount) {
        $controlCont.find("[data-ratingRowCount='" + ratingRowCount + "']").removeAttr("data-ratingRowCount");
      }

      // Update the weighting sum
      var starVal = $starControl.val();
      var ratingId = $starControl.attr("data-rateId");

      var $weightValueCont = $controlCont.find("[data-weightValueFor='" + ratingId + "']");
      var weighting = $weightValueCont.find("[data-weighting]").attr("data-weighting");

      var weightValue = starVal * weighting;
      $weightValueCont.find(".weighting-sum").html(weightValue);

      // Update the total score
      TECL_UserTenderEvaluationStage.UpdateTotalScore($controlCont);
    });

  },

  /*
   * Method used to update the total score of an award criteria control
   */
  UpdateTotalScore: function($controlCont) {

    var hasUnfilledStars = $controlCont.find("[data-ratingRowCount]").length > 0;

    if (!hasUnfilledStars) {

      $controlCont.find(".total-rating-score").removeClass("hidden");
      $controlCont.find(".total-rating-score-alt").addClass("hidden");
      var $totalScoreContainer = $controlCont.find(".total-rating-score-cont");

      // Ensure reject/select buttons are visible
      var $rejectSelectBtnCont = $controlCont.closest(".tender-user-supplier-listing").find("[name='supplierStatusButtons']");

      if ($rejectSelectBtnCont.hasClass("reject-select-disabled")) {

        // Remove the disabled class
        $rejectSelectBtnCont.removeClass("reject-select-disabled");
        // Set the titles
        $rejectSelectBtnCont.find("[data-titleAlt]").each(function() {
          var $btn = $(this);
          $btn.prop("title", $btn.attr("data-titleAlt"));
        });
      }

      // Get the total possible score
      var totalPossibleScore = parseInt($totalScoreContainer.attr("data-totalPossibleScore"));

      // Calc the actual score
      var actualScore = 0;
      $controlCont.find("[name='ratingCriteriaValue']").each(function() {
        var $thisStar = $(this);
        var starVal = $thisStar.val();
        var rateWeight = parseInt($thisStar.attr("data-weight"));
        actualScore += (starVal * rateWeight);
      });

      // Get the score as a percentage
      var percentScore = (actualScore / totalPossibleScore) * 100;
      percentScore = percentScore.toFixed(0);

      var percentOutput = percentScore === "NaN" ? "0" : percentScore;

      // Write the value
      $totalScoreContainer.find(".total-rating-score").html(percentOutput);
      // Ensure score is enabled
      $totalScoreContainer.removeClass("score-disabled");
    }
  }

};

